export type ItemAliasRow = { id?: number; alias_name: string };

export function parseItemAliases(raw: unknown): ItemAliasRow[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((row) => {
      if (!row || typeof row !== 'object') return null;
      const alias_name = String((row as { alias_name?: unknown }).alias_name ?? '').trim();
      if (!alias_name) return null;
      const idRaw = (row as { id?: unknown }).id;
      const id = idRaw != null && idRaw !== '' ? Number(idRaw) : undefined;
      return { alias_name, ...(id != null && !Number.isNaN(id) ? { id } : {}) };
    })
    .filter((row): row is ItemAliasRow => row != null);
}

export function itemAliasNames(aliases: ItemAliasRow[]): string[] {
  return aliases.map((a) => a.alias_name);
}

/** Summary for table cells: list up to 2 names, otherwise "N aliases" with full list in title. */
export function formatItemAliasesSummary(aliases: ItemAliasRow[]): { label: string; title: string | undefined } {
  const names = itemAliasNames(aliases);
  if (names.length === 0) return { label: '—', title: undefined };
  if (names.length <= 2) return { label: names.join(', '), title: undefined };
  return { label: `${names.length} Aliases`, title: names.join('\n') };
}
